export default (params) => ({
  trigger: {
    name: 'content_blocks.newsletter.select_email_input_field',
    params: params,
  },
  config: {
    schema: {
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_input_field',
      params: {
        sub_feature: null,
        input_field: 'newsletter_email',
        status: 'focus',
        content: null,
      },
    },
  },
});
